import jsepObject from '@jsep-plugin/object'
import jsep from 'jsep'

jsep.plugins.register(jsepObject)
